(() => {
  const init = (root) => {
    if (!root || root.dataset.svdcReady === 'true') return;
    root.dataset.svdcReady = 'true';

    const buttons = Array.from(root.querySelectorAll('[data-svdc-filter]'));
    const cards = Array.from(root.querySelectorAll('[data-svdc-product-card]'));
    const sections = Array.from(root.querySelectorAll('[data-svdc-filter-section]'));
    const status = root.querySelector('[data-svdc-status]');
    const shop = root.querySelector('#svdc-shop');

    const labels = {
      all: 'the full 10-piece edit',
      puja: 'Puja Morning picks',
      evening: 'Diwali Evening picks',
      newyear: 'New Year Visit picks',
      trip: 'Festive Travel picks'
    };

    const applyFilter = (filter, shouldScroll = true) => {
      let visibleCount = 0;

      cards.forEach((card) => {
        const occasions = (card.dataset.svdcOccasions || '')
          .split(',')
          .map((item) => item.trim())
          .filter(Boolean);

        const show = filter === 'all' || occasions.includes(filter);
        card.hidden = !show;
        if (show) visibleCount += 1;
      });

      sections.forEach((section) => {
        const visibleCards = section.querySelectorAll(
          '[data-svdc-product-card]:not([hidden])'
        );
        section.hidden = visibleCards.length === 0;
      });

      buttons.forEach((button) => {
        const active = button.dataset.svdcFilter === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (status) {
        status.textContent = filter === 'all'
          ? 'Showing the full 10-piece edit.'
          : `Showing ${visibleCount} ${labels[filter] || 'Diwali picks'}.`;
      }

      if (shouldScroll && shop) {
        shop.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        applyFilter(button.dataset.svdcFilter);
      });
    });

    applyFilter('all', false);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-svdc-root]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
